import { useState } from 'react';

import { Playground } from '../../../components/playground/Playground';
import { Headline } from '../../../components/Headline';
import { Note } from '../../../components/Note';
import Switch from '@rio-cloud/rio-uikit/Switch';

import ClearableInput from '@rio-cloud/rio-uikit/ClearableInput';
import FormLabel from '@rio-cloud/rio-uikit/FormLabel';
import { icons as iconList } from '../../../../../uikit-icons/generated/IconsPreview';
import { iconsMetaData } from '../../../../../uikit-icons/generated/iconsMetaData';
import type { IconType } from '@rio-cloud/rio-uikit/components/icon/IconType';
import packageJson from '../../../../../package.json';

const CDN_URL = 'https://uikit.developers.rio.cloud';

export const IconLibrary = () => (
    <div className='uikit-icons'>
        <Headline anchor='iconLibrary'>Icon library</Headline>
        <Note label='Download' type='success'>
            Download all icons as SVG images{' '}
            <a href={`${CDN_URL}/${packageJson.version}/uikit-icons.zip`} target='_blank' rel='noreferrer'>
                here.
            </a>
        </Note>
        <Playground example={<IconLibraryExample />} />
    </div>
);

const IconLibraryExample = () => {
    const isProd = import.meta.env.PROD || location.protocol.startsWith('https');

    const [icons, setIcons] = useState<IconType[]>((iconList ?? []) as IconType[]);
    const [filterValue, setFilterValue] = useState('');
    const [filledIcons, setFilledIcons] = useState(false);
    const [disabledIcons, setDisabledIcons] = useState(false);

    const handleFilterIcons = (value: string) => {
        const filterByNameResult = (iconList as IconType[]).filter(
            icon => icon.includes(value) || iconsMetaData[icon as IconType]?.toLowerCase().includes(value.toLowerCase())
        );
        setIcons(filterByNameResult);
        setFilterValue(value);
    };

    const handleFilledSwitch = () => {
        setFilledIcons(prevState => !prevState);
    };

    const handleDisabledSwitch = () => {
        setDisabledIcons(prevState => !prevState);
    };

    return (
        <>
            <div className='display-flex gap-15 flex-column-xs margin-bottom-15'>
                <div className='max-width-300 flex-1-1'>
                    <FormLabel htmlFor='iconNameFilter'>Search</FormLabel>
                    <div className='input-group width-100pct'>
                        <span className='input-group-addon'>
                            <span className='uikit-icon icon-search' aria-hidden='true' />
                        </span>
                        <ClearableInput
                            id='iconNameFilter'
                            value={filterValue}
                            placeholder='Filter by icon name'
                            onChange={handleFilterIcons}
                        />
                    </div>
                </div>
                {!isProd && (
                    <div className='display-flex gap-15'>
                        <div>
                            <FormLabel>Filled icons</FormLabel>
                            <Switch
                                onChange={handleFilledSwitch}
                                checked={filledIcons}
                                minWidth={50}
                                enabledText='On'
                                disabledText='OFF'
                            />
                        </div>

                        <div>
                            <FormLabel>Disabled icons</FormLabel>
                            <Switch
                                onChange={handleDisabledSwitch}
                                checked={disabledIcons}
                                minWidth={50}
                                enabledText='On'
                                disabledText='OFF'
                            />
                        </div>
                    </div>
                )}
            </div>
            <div className='display-flex flex-wrap column-gap-10'>
                {icons?.map(icon => (
                    <div
                        key={icon}
                        className='uikit-icon-preview display-flex align-items-center margin-top-10 margin-bottom-10'
                    >
                        <span
                            className={`uikit-icon ${icon} ${filledIcons ? 'uikit-icon-filled' : ''} ${disabledIcons ? 'uikit-icon-disabled' : ''} text-size-h3 margin-right-10`}
                        />
                        <span className='text-light user-select-all'>{`uikit-icon ${icon} ${filledIcons ? 'uikit-icon-filled' : ''} ${disabledIcons ? 'uikit-icon-disabled' : ''}`}</span>
                    </div>
                ))}
            </div>
        </>
    );
};
